
<div class="case-overview__container mt-5 text-center">
  <p [innerHTML]="redirectURL ? ('Finish.Text' | translate) : ('Finish.NoRedirect' | translate)"></p>
</div>
